import { getToken } from "../api/client";
import { getApiOrigin } from "./apiOrigin";

export interface HostMetricsMessage {
  _type?: string;
  ts: string;
  host: {
    cpu_percent: number;
    cpu_count_logical: number;
    cpu_count_physical: number;
    load_avg: number[] | null;
    boot_time_unix: number;
  };
  memory: {
    percent: number;
    used_bytes: number;
    total_bytes: number;
    available_bytes: number;
  };
  swap: {
    percent: number;
    used_bytes: number;
    total_bytes: number;
  };
  disk: {
    path: string;
    total_bytes: number;
    used_bytes: number;
    free_bytes: number;
    percent: number;
  } | null;
}

/** 生产环境连 api 域名的 wss；开发环境走当前页（Vite 代理） */
export function buildHostMetricsWebSocketUrl(): string | null {
  if (typeof window === "undefined") return null;
  const t = getToken();
  if (!t) return null;
  const origin = getApiOrigin();
  if (origin) {
    try {
      const u = new URL(origin);
      const wsProto = u.protocol === "https:" ? "wss:" : "ws:";
      return `${wsProto}//${u.host}/api/admin/host-metrics/ws?token=${encodeURIComponent(t)}`;
    } catch {
      return null;
    }
  }
  const proto = window.location.protocol === "https:" ? "wss:" : "ws:";
  return `${proto}//${window.location.host}/api/admin/host-metrics/ws?token=${encodeURIComponent(t)}`;
}
